module.exports = __webpack_public_path__ + "img/vers_03-02.31998715.svg";